module.exports = __webpack_public_path__ + "a1697aa3c409b5b77a260d5c2ad12c29.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/verrat_inactive.svg
// module id = 147
// module chunks = 0